export const months = ['января','февраля','марта','апреля','мая','июня','июля','августа','сентября','октября','ноября','декабря'];
export const windDescribe= ['Штиль','Северный','Северо-восточный','Восточный','Юго-восточный','Южный','Юго-западный','Западный','Северо-западный'];


// WEBPACK FOOTER //
// ./src/constants.js